import { GET_STORE_ALL } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_STORE_ALL:
            return action.payload;
        default:
            return state;
    }
}
